import React from "react";
import classNames from "classnames";

export default ({ children, open=false }) => (
  <div className={classNames({
    'ngh-AppBar--Nav': true,
    'ngh-AppBar--Nav__open': open
  })}>{children}</div>
);
